"use client";
import * as React from "react";
const SvgSortOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 11", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 11h5.33V9.17H0zM0 0v1.83h16V0zm0 6.42h10.67V4.58H0z" }));
export {
  SvgSortOutlined as default
};
